import { persistTrackingData } from '../util';
import { initDataLayer } from '../util/initDataLayer';
import { isBrowser } from '../util/isBrowser';
export function pushBoardSelection(estabId, boardDescription, boardUpgraded) {
    if (!isBrowser())
        return;
    initDataLayer();
    window.dataLayer.push({
        event: 'updateBoardSelection',
        selectedBoard: { estabId, boardDescription },
        boardUpgraded,
    });
    persistTrackingData({ selectedBoard: { estabId, boardDescription }, boardUpgraded });
}
